// pages/SitePages.js - full pages built from the shared sections
import React from 'react';
import Home from './Home/Home';
import Services from './Services/Services';
import Portfolio from './Portfolio/Portfolio';
import About from './About/About';
import Process from './Process/Process';
import Testimonials from './Testimonials/Testimonials';
import Contact from './Contact/Contact';
import WhyChooseUs from './WhyChooseUs/WhyChooseUs';
import PageHeader from '../components/PageHeader';
import CtaBanner from '../components/CtaBanner';
import usePageTitle from '../hooks/usePageTitle';

export const HomePage = () => {
    usePageTitle();

    return (
        <>
            <Home />
            <Services limit={6} />
            <Portfolio limit={6} />
            <WhyChooseUs />
            <Testimonials />
            <CtaBanner />
        </>
    );
};

export const AboutPage = () => {
    usePageTitle('About Us', 'Meet the GForce Solutions team: full stack developers building websites, CRMs and SaaS platforms since 2021.');

    return (
        <>
            <PageHeader
                title="About Us"
                subtitle="A team of developers and designers building websites, CRMs and SaaS platforms for businesses worldwide"
                breadcrumbs={[{ label: 'About' }]}
            />
            <About />
            <WhyChooseUs />
            <CtaBanner />
        </>
    );
};

export const ServicesPage = () => {
    usePageTitle('Services', 'SaaS & CRM development, React & Next.js apps, e-commerce, backend APIs, UI/UX design and SEO services by GForce Solutions.');

    return (
        <>
            <PageHeader
                title="Our Services"
                subtitle="Everything you need to build, launch and grow your digital product"
                breadcrumbs={[{ label: 'Services' }]}
            />
            <Services showHeader={false} />
            <Process />
            <CtaBanner />
        </>
    );
};

export const PortfolioPage = () => {
    usePageTitle('Portfolio', 'Live projects by GForce Solutions: SaaS CRMs, real estate marketplaces, education portals and more.');

    return (
        <>
            <PageHeader
                title="Our Portfolio"
                subtitle="Real projects, live in production, for clients in Pakistan, Europe and Africa"
                breadcrumbs={[{ label: 'Portfolio' }]}
            />
            <Portfolio showHeader={false} showFilters />
            <CtaBanner />
        </>
    );
};

export const ProcessPage = () => {
    usePageTitle('Our Process');

    return (
        <>
            <PageHeader
                title="Our Process"
                subtitle="A clear, step-by-step way of working so you always know what happens next"
                breadcrumbs={[{ label: 'Process' }]}
            />
            <Process />
        </>
    );
};

export const TestimonialsPage = () => {
    usePageTitle('Testimonials');

    return (
        <>
            <PageHeader
                title="Client Testimonials"
                subtitle="What our clients say about working with us"
                breadcrumbs={[{ label: 'Testimonials' }]}
            />
            <Testimonials />
        </>
    );
};

export const ContactPage = ({ budgetData }) => {
    usePageTitle('Contact Us', 'Contact GForce Solutions for a free consultation and project quote. Call or WhatsApp +92 309 8373032.');

    return (
        <>
            <PageHeader
                title="Contact Us"
                subtitle="Tell us about your project and get a free consultation within 24 hours"
                breadcrumbs={[{ label: 'Contact' }]}
            />
            <Contact budgetData={budgetData} />
        </>
    );
};
